import { ThemeProvider } from '../../contexts/ThemeContext'
import LandingNavbar from './LandingNavbar'
import HeroSection from './HeroSection'
import StatsBar from './StatsBar'
import TestimonialsSection from './TestimonialsSection'
import HowItWorks from './HowItWorks'
import FeaturesSection from './FeaturesSection'
import SecuritySection from './SecuritySection'
import PricingSection from './PricingSection'
import UseCasesSection from './UseCasesSection'
import FAQSection from './FAQSection'
import LandingFooter from './LandingFooter'

export default function LandingPage() {
  return (
    <ThemeProvider switchable>
      <div className="min-h-screen bg-white dark:bg-gray-900" style={{ fontFamily: "'DM Sans', sans-serif" }}>
        <LandingNavbar />
        <HeroSection />
        <StatsBar />
        <TestimonialsSection />
        <HowItWorks />
        <FeaturesSection />
        <SecuritySection />
        <PricingSection />
        <UseCasesSection />
        <FAQSection />
        <LandingFooter />
      </div>
    </ThemeProvider>
  )
}
